import React, { Component, PropTypes } from 'react'
import { logout, resetNetwork } from '../actions'
import { connect } from 'react-redux'
import Loading from './loading'
import Progress from './progress'
import Maintenance from './maintenance'
import Error from './error'
import Nav from './nav'

class Root extends Component {
  render() {
    const { appState } = this.props
    const {
      authenticated,
      networkProgress,
      networkFailed,
      subscriptionProgress,
      maintenance,
    } = appState.toJS()

    return (
      <div>
        {networkProgress ? <Loading /> : null}
        {subscriptionProgress ? <Progress /> : null}
        {networkFailed ? <Error onClose={this.resetNetwork} /> : null}
        {maintenance ? <Maintenance onClose={this.resetNetwork} /> : null}
        {authenticated ? (
          <div className='c-layout'>
            <Nav authenticated={authenticated} onLogOut={this.onLogOut} />
            <div className='mp-content'>{this.props.children}</div>
          </div>
        ) : (
          this.props.children
        )}
      </div>
    )
  }

  onLogOut = ev => {
    let { dispatch } = this.props
    ev.preventDefault()
    dispatch(logout())
  }

  resetNetwork = () => {
    let { dispatch } = this.props
    dispatch(resetNetwork())
  }
}

Root.propTypes = {
  dispatch: PropTypes.func.isRequired,
  appState: PropTypes.object.isRequired,
}

function propProvider(reduxState, props) {
  const { appState } = reduxState

  return {
    appState,
  }
}

export default connect(propProvider)(Root)
